import { getPartsInventory } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { get } from "react-hook-form";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
	setListAllParts: Function;
};

export const useSearchParts = ({
	setIsLoading,
	setError,
	setListAllParts,
}: Props) => {
	return async (partSearch?: string) => {
		setIsLoading(true);
		const res = await getPartsInventory(partSearch || null);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setListAllParts(rowsSource);

			setIsLoading(false);
		} else {
			setError(res.message);
			setIsLoading(false);
		}
	};
};
